import { render, staticRenderFns } from "./insurance.block.vue?vue&type=template&id=27c5592f&scoped=true"
import script from "./insurance.block.vue?vue&type=script&lang=js"
export * from "./insurance.block.vue?vue&type=script&lang=js"
import style0 from "./insurance.block.vue?vue&type=style&index=0&id=27c5592f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5592f",
  null
  
)

export default component.exports